module.exports = __webpack_public_path__ + "static/Bressay-BoldItalic-acc2a9450dfcaade0b6cc75f6c382ba0.ttf";